import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch, setToken } from '../dppApi';
import '../App.css';

// Brand login / registration. On success, stores the brand JWT and goes to
// the dashboard where products are created.
const BrandAuth = () => {
    const navigate = useNavigate();
    const [mode, setMode] = useState('login'); // 'login' | 'register'
    const [form, setForm] = useState({ name: '', email: '', password: '' });
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setBusy(true);
        try {
            const path = mode === 'login' ? '/api/brand/login' : '/api/brand/register';
            const body = mode === 'login'
                ? { email: form.email, password: form.password }
                : form;
            const data = await apiFetch(path, { method: 'POST', body });
            setToken('brand', data.token);
            navigate('/brand/dashboard');
        } catch (err) {
            setError(err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="dpp-auth-page">
            <form className="dpp-auth-card" onSubmit={handleSubmit}>
                <h1 className="dpp-auth-title">Brand {mode === 'login' ? 'Login' : 'Sign Up'}</h1>

                {mode === 'register' && (
                    <input className="dpp-input" placeholder="Brand name" value={form.name}
                        onChange={update('name')} required />
                )}
                <input className="dpp-input" type="email" placeholder="Email" value={form.email}
                    onChange={update('email')} required />
                <input className="dpp-input" type="password" placeholder="Password" value={form.password}
                    onChange={update('password')} required />

                {error && <p className="dpp-error">{error}</p>}

                <button className="dpp-button" type="submit" disabled={busy}>
                    {busy ? 'Please wait…' : (mode === 'login' ? 'Log In' : 'Create Account')}
                </button>

                <button type="button" className="dpp-link-button"
                    onClick={() => { setError(null); setMode(mode === 'login' ? 'register' : 'login'); }}>
                    {mode === 'login' ? "Need an account? Sign up" : 'Have an account? Log in'}
                </button>
            </form>
        </div>
    );
};

export default BrandAuth;
